export const setGtm = (eventName: string): void => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
    });
  }
};